import React from 'react';
import PropTypes from 'prop-types';

// Interpolate from red (#f44336) to dark red (#4a0000) based on 0–1 factor
const lerpColor = (factor) => {
    const r = Math.round(244 - factor * (244 - 74));
    const g = Math.round(67 - factor * (67 - 0));
    const b = Math.round(54 - factor * (54 - 0));
    return `rgb(${r}, ${g}, ${b})`;
};

export const getPitcherFatigueTier = (pitcherWork, stamina) => {
    const overage = pitcherWork - stamina;
    const pct = Math.min(1, pitcherWork / stamina);
    if (pct < 0.5) return 'Fresh';
    if (pct < 0.75) return 'Working';
    if (pct < 1) return 'Tiring';
    if (overage <= 5) return 'Fatigued';
    if (overage <= 15) return 'Gassed';
    return 'Cooked';
};

const PitcherFatigue = ({ pitcherWork = 0, stamina = 27, showLabel = false }) => {
    const overage = pitcherWork - stamina;
    const pct = Math.min(1, pitcherWork / stamina);
    const isExhausted = overage >= 0;

    let tier, circleColor;
    if (pct < 0.5) {
        tier = 'Fresh';
        circleColor = '#0E8004';
    } else if (pct < 0.75) {
        tier = 'Working';
        circleColor = '#ffca28';
    } else if (pct < 1) {
        tier = 'Tiring';
        circleColor = '#ff9800';
    } else {
        const darkFactor = Math.min(1, overage / 16);
        circleColor = lerpColor(darkFactor);
        if (overage <= 5) tier = 'Fatigued';
        else if (overage <= 15) tier = 'Gassed';
        else tier = 'Cooked';
    }

    return (
        <span className="pitcher-fatigue-indicator">
            {showLabel && (
                <span
                    className={isExhausted ? 'fatigue-exhausted-label' : 'fatigue-tier-label'}
                    style={isExhausted ? undefined : { color: circleColor }}
                >
                    {tier}
                </span>
            )}
            <span className="fatigue-dot" style={{ backgroundColor: circleColor }} />
        </span>
    );
};

PitcherFatigue.propTypes = {
    pitcherWork: PropTypes.number,
    stamina: PropTypes.number,
    showLabel: PropTypes.bool,
};

export default PitcherFatigue;
